'use strict';
module.exports = require('./AccordionTab.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/accordiontab/index.js
// module id = 96
// module chunks = 7